import React from "react";

import healthcareImg from "../../../assets/EMP_industriesoverview/Overviewcardimg/healthcare-artwork.webp";

import retailImg from "../../../assets/EMP_industriesoverview/Overviewcardimg/figure-retail.svg";

import restaurantImg from "../../../assets/EMP_industriesoverview/Overviewcardimg/restaurant-qsr-artwork.webp";

import travelImg from "../../../assets/EMP_industriesoverview/Overviewcardimg/figure-hospitality.svg";

import groceryImg from "../../../assets/EMP_industriesoverview/Overviewcardimg/grocers-artwork.webp";

import contactImg from "../../../assets/EMP_industriesoverview/Overviewcardimg/figure-callcenter.svg";

import manufacturingImg from "../../../assets/EMP_industriesoverview/Overviewcardimg/manufacturing.svg";

import publicSectorImg from "../../../assets/EMP_industriesoverview/Overviewcardimg/public-sector-industries.webp";

import hospitalityImg from "../../../assets/EMP_industriesoverview/Overviewcardimg/hotel-luggage.webp";

const industries = [
  {
    title: "Hospitals & Healthcare",
    desc: "Hospital systems, home care companies and others across the healthcare industry should consider strategies to offer more resources for employees. Companies can consider how on-demand pay may help employees with their financial and mental well-being.",
    bg: "bg-[#c9dfcf]",
    img: healthcareImg,
  },
  {
    title: "Retail",
    desc: "Retailers are facing record-high resignation rates and a highly competitive labor market, coupled with new consumer habits and expectations as we move out of the pandemic. To help retain staff and keep employees satisfied, retailers are turning to on-demand pay.",
    bg: "bg-[#ead5e5]",
    img: retailImg,
  },
  {
    title: "Restaurants & QSR",
    desc:"The ongoing labor shortage, supply chain issues, and inflation are all complicating matters as restaurants look to recoup their losses throughout the pandemic. To address these various challenges, restaurant owners must prioritize staff retention and satisfaction to improve customer service.",
 bg: "bg-[#cfe8ed]",
    img: restaurantImg,
  },
  {
    title: "Travel & Hospitality",
 desc:"A reluctant labor pool and poor retention rates are two of the main struggles the industry faces as it tries to win back workers. Companies are turning to on-demand pay for quickly attract new workers and retain their employees.",   bg: "bg-[#f2e1c4]",
    img: travelImg,
  },
  {
    title: "Grocers & Supermarkets",
    desc:"The grocer & supermarket industry suffers from a high turnover rate which can have adverse effects on businesses. On-Demand Pay can increase retention and improve hiring, saving money and helping to improve customer service and profitability.",
    bg: "bg-[#c9dfcf]",
    img: groceryImg,
  },
  {
    title: "Call & Contact Centers",
    desc: "Keeping employees motivated and engaged can make all the difference when dealing with potential customers over the phone. To help retain staff and keep employees satisfied, retailers are turning to on-demand pay.",
    bg: "bg-[#ead5e5]",
    img: contactImg,
  },
  {
    title: "Manufacturing",
    desc: "Companies are addressing ongoing challenges with an employee-first culture backed by on-demand pay. A generational shift in the workforce, widespread adoption of new technologies and ongoing economic uncertainties are challenging the industry to adapt and evolve.",
    bg: "bg-[#cfe8ed]",
    img: manufacturingImg,
  },
  {
    title: "Public Sector",
    desc: " A significant portion of the public sector’s workforce, including educators, healthcare workers, law enforcement, and government officials, is expected to retire within the next 5-7 years. This looming wave of retirements presents both challenges and opportunities for rejuvenation across various public sector domains. The public sector must set itself apart from other industries and attract and retain the next generation of workers.",
    bg: "bg-[#f2e1c4]",
    img: publicSectorImg,
  },
  {
    title: "Hospitality",
    desc: "Learn how modern payment solutions can improve employee retention and satisfaction in hospitality industries.",
    bg: "bg-[#d9d9d9]",
    img: hospitalityImg,
  },
];

const Overviewcards = () => {
return (
  <section className="w-full bg-white py-10 sm:py-16">
  <div className="max-w-[1350px] mx-auto px-5 sm:px-6 lg:px-10">

    <div
      className="
        grid
        grid-cols-1
        xl:grid-cols-3
        gap-5
      "
    >
      {industries.map((item, index) => (
        <div
          key={index}
          className={`
            ${index === 8 ? "bg-white" : item.bg}

            ${
              index === 8
                ? "h-[580px] p-0"
                : "h-[580px] p-6 md:p-8"
            }

            overflow-hidden
            flex
            flex-col
            justify-between

            transition-all
            duration-300
            hover:scale-[1.02]
          `}
        >

          {/* LAST CARD FULL IMAGE */}
          {index === 8 ? (
            <img
              src={item.img}
              alt={item.title}
              className="
                w-full
                h-full
                object-cover
                object-center
                block
              "
            />
          ) : (
            <>
              {/* CONTENT */}
              <div>
                <h2
                  className="
                    text-[28px]
                    md:text-[30px]
                    lg:text-[35px]
                    leading-[1.1]
                    font-serif
                    text-[#100f0f]
                    max-w-[350px]
                  "
                  style={{
                    fontFamily:
                      '"Cormorant Garamond", serif',
                  }}
                >
                  {item.title}
                </h2>

                <p
                  className="
                    mt-6
                    text-[16px]
                    md:text-[16px]
                    md:font-[450]
                    leading-[1.5]
                    lg:leading-[1.5]
                    text-[#151515]
                    w-full
                    lg:max-w-[390px]
                  "
                >
                  {item.desc}
                </p>

                <button
                  className="
                    mt-10
                    mx-auto
                    md:mx-0
                    text-[17px]
                    font-semibold
                    flex
                    items-center
                    gap-2
                    hover:gap-3
                    transition-all
                    duration-300
                  "
                >
                  Learn more
                  <span>›</span>
                </button>
              </div>

              {/* SMALLER IMAGE */}
              <div
                className="
                  w-full
                  flex
                  justify-end
                  items-end
                  mt-8
                  h-[220px]
                "
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className={`
                    object-contain
                    select-none

                    ${
                      index === 0
                        ? "w-[190px] lg:w-[270px] max-h-[240px] -mb-8"
                        : index === 1
                        ? "w-[190px] lg:w-[290px] max-h-[290px] lg:h-[280px] lg:ml-[200px]"
                        : index === 2
                        ? "w-[190px] lg:w-[250px] max-h-[220px] lg:ml-[130px]"
                        : index === 3
                        ? "w-[190px] lg:w-[270px] max-h-[240px] lg:ml-[150px] lg:-mb-8 "
                        : index === 4
                        ? "w-[190px] lg:w-[270px] max-h-[270px]  lg:ml-[120px] lg:-mb-10 "
                        : index === 5
                        ? "w-[190px] lg:w-[270px] max-h-[220px] -mb-10"
                        : index === 6
                        ? "w-[190px] lg:w-[270px] max-h-[280px] lg:h-[255px] lg:ml-[200px]"
                        : index === 7
                        ? "w-[190px] lg:w-[300px] max-h-[270px] lg:h-[260] lg:mb-4"
                        : "w-[190px] lg:w-[270px] max-h-[220px]"
                    }
                  `}
                />
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  </div>
</section>
);
};

export default Overviewcards;